import Menu from 'components/Menu'
import RoundyContainer from 'components/RoundyContainer'
import { AddressChangeContext, AddressChangeContextComp } from 'components/StraightThroughAddressComp/AddressContext/AddressChangeContext'
import AddressProgressBreadCrumb from 'components/StraightThroughAddressComp/AddressProgressBar/AddressProgressBreadCrumb'
import ChangeAddressMain from 'components/StraightThroughAddressComp/1_NewAddress/ChangeAddress_Main'
import AddressDisclosureAgreement from 'components/StraightThroughAddressComp/DisclosureAgreement/AddressDisclosureAgreement'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { storageData } from 'services/Services'

const ChangeAddress = (props) => {
  const navigate = useNavigate()
  const { userData } = props.user
  const [showModal, setShowModal] = useState(true);
  const websiteMaintenance = JSON.parse(storageData?.getItem("websiteMaintenance"));

  const handleClose = () => {
    setShowModal(false);
    userData["disclosureModal"] = true
    storageData.setItem("userData", JSON.stringify(userData));
  }

  useEffect(() => {
    window.scrollTo(0, 0)

    // Redirect to maintenance page if maintenance is on for COA Endorsement
    if (websiteMaintenance?.status?.Result == "Active" && websiteMaintenance?.status?.Pages?.includes("EndorsementAddress")) {
      navigate("/maintenance")
      return
    }
  }, [])

  return (
    <>
      <AddressChangeContextComp>
        <Menu Title={"ADDRESS CHANGE"} FirstName={userData.firstName} userData={userData} />
        <AddressProgressBreadCrumb requestContext={AddressChangeContext} />
        <RoundyContainer
          Content={ChangeAddressMain}
          NoRoundy
        />

        {!userData?.disclosureModal &&
          <AddressDisclosureAgreement
            showModal={showModal}
            handleClose={handleClose}
            title="DISCLOSURE AGREEMENT"
            policyState={userData.state}
          />
        }
      </AddressChangeContextComp>
    </>
  )
}

export default ChangeAddress